<template>
  <b-modal
    id="select-item-modal"
    ref="select-item-modal"
    size="xl"
    scrollable
    hide-footer
    :title="$t('Add Record',{ label: singleLabel })"
  >
    <list :module="module" emit-event-on-click-row @rowClicked="handleClickRow" />
  </b-modal>
</template>

<script>

import {
  BModal,
} from 'bootstrap-vue'
import List from '@/views/modules/core/list/List.vue'

export default {
  name: 'SelectItemModal',
  components: {
    List,
    BModal,
  },
  props: {
    module: {
      type: String,
      default: () => '',
    },
  },
  methods: {
    handleClickRow(item) {
      this.$emit('select', item)
      this.$refs['select-item-modal'].hide()
    },
  },
}
</script>

<style scoped>

</style>
